module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "overlayFade"
    }
  }, [(_vm.displayCredits) ? _c('div', {
    staticClass: "credits__wrapper"
  }, [_c('section', {
    staticClass: "section"
  }, [_c('div', {
    staticClass: "section__wrapper"
  }, [_c('div', {
    staticClass: "section__content"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'view-home'
      }
    }
  }, [_c('img', {
    staticClass: "credits__hero",
    attrs: {
      "src": require("../assets/BTAB_svg_inverted.svg"),
      "alt": "Britain Take A Bow"
    }
  })])], 1), _vm._v(" "), _c('div', {
    staticClass: "credits__close-icon-wrapper",
    on: {
      "click": _vm.hideCredits
    }
  }, [_c('img', {
    staticClass: "credits__close-icon",
    attrs: {
      "src": require("../assets/close_icon.svg"),
      "alt": "Close credits"
    }
  })])])]), _vm._v(" "), _c('section', {
    staticClass: "section"
  }, [_c('div', {
    staticClass: "section__wrapper"
  }, [_c('div', {
    staticClass: "section__content"
  }, [_c('div', {
    staticClass: "credits__top-section"
  }, [_c('button', {
    staticClass: "mb-2 mr-2 button inverted",
    on: {
      "click": _vm.replayVideo
    }
  }, [_vm._v("Play again")]), _vm._v(" "), _c('button', {
    staticClass: "mb-2 mr-3 button",
    on: {
      "click": _vm.reload
    }
  }, [_vm._v("Load a new version")]), _vm._v(" "), _c('div', {
    staticClass: "mb-2 credits__share-links"
  }, [_c('span', {
    staticClass: "credits__share-label mr-3"
  }, [_vm._v("Share:")]), _vm._v(" "), _c('img', {
    directives: [{
      name: "sharer",
      rawName: "v-sharer"
    }],
    staticClass: "footer__social-icon mr-3",
    attrs: {
      "data-sharer": "twitter",
      "data-title": "Britain, Take A Bow!",
      "data-url": "https://britaintakeabow.org",
      "src": require("../assets/icon_twitter_dark.svg"),
      "alt": "Twitter icon"
    }
  }), _vm._v(" "), _c('img', {
    directives: [{
      name: "sharer",
      rawName: "v-sharer"
    }],
    staticClass: "footer__social-icon mr-3",
    attrs: {
      "data-sharer": "facebook",
      "data-url": "https://britaintakeabow.org",
      "src": require("../assets/icon_facebook_dark.svg"),
      "alt": "Facebook icon"
    }
  }), _vm._v(" "), _c('img', {
    directives: [{
      name: "sharer",
      rawName: "v-sharer"
    }],
    staticClass: "footer__social-icon mr-3",
    attrs: {
      "data-sharer": "linkedin",
      "data-url": "https://britaintakeabow.org",
      "src": require("../assets/icon_linkedin_dark.svg"),
      "alt": "LinkedIn icon"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "credits__grid"
  }, [_c('div', {
    staticClass: "credits__grid-item credits__grid-item--has-heading"
  }, [_c('p', {
    staticClass: "credits__grid-item-heading"
  }, [_vm._v("By:")]), _vm._v(" "), _c('p', [_vm._v("Graeme Crowley")])]), _vm._v(" "), _c('div', {
    staticClass: "credits__grid-item credits__grid-item--has-heading"
  }, [_c('p', {
    staticClass: "credits__grid-item-heading"
  }, [_vm._v("Special thanks to:")]), _vm._v(" "), _c('p', [_vm._v("Audio production by Paul Crowley")]), _vm._v(" "), _c('p', [_c('a', {
    staticClass: "credits__link",
    attrs: {
      "href": "https://www.linkedin.com/in/jackhardiker?originalSubdomain=uk"
    }
  }, [_vm._v("Jack Hardiker")]), _vm._v(" and "), _c('a', {
    staticClass: "credits__link",
    attrs: {
      "href": "https://vimeo.com/259905941"
    }
  }, [_vm._v("Midnight Oil")])]), _vm._v(" "), _c('p', [_c('a', {
    staticClass: "credits__link",
    attrs: {
      "href": "http://simonellisfilms.com"
    }
  }, [_vm._v("Simon Ellis")])])]), _vm._v(" "), _c('div', {
    staticClass: "credits__grid-item credits__grid-item--has-heading"
  }, [_c('p', {
    staticClass: "credits__grid-item-heading"
  }), _vm._v(" "), _c('p', [_vm._v("Richard Baker")]), _vm._v(" "), _c('p', [_vm._v("Horace Keating")]), _vm._v(" "), _c('p', [_c('a', {
    staticClass: "credits__link",
    attrs: {
      "href": "https://www.tuimedia.com"
    }
  }, [_c('img', {
    staticClass: "credits__link-img",
    attrs: {
      "src": require("../assets/tuiLogo.svg"),
      "alt": "Tui Media"
    }
  })])])]), _vm._v(" "), (_vm.typoCredit) ? _c('div', {
    staticClass: "credits__grid-item credits__grid-item--has-heading"
  }, [_c('p', {
    staticClass: "credits__grid-item-heading"
  }, [_vm._v("Typography:")]), _vm._v(" "), _c('p', {
    staticClass: "credits__grid-item-name"
  }, [_vm._v(_vm._s(_vm.typoCredit.name))]), _vm._v(" "), _vm._l((_vm.getLinksFromCredit(_vm.typoCredit.credit)), function(link, index) {
    return _c('a', {
      key: ("credit-" + (_vm.typoCredit.fullName) + "-" + index),
      staticClass: "credits__grid-item-credit credits__link",
      attrs: {
        "href": link.link,
        "target": "_blank"
      }
    }, [_vm._v("\n                " + _vm._s(link.label) + "\n              ")])
  })], 2) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "credits__grid"
  }, [_c('div', {
    staticClass: "credits__grid-item"
  }, [_c('p', [_c('a', {
    staticClass: "credits__link",
    attrs: {
      "href": "http://www.royalspabrass.com"
    }
  }, [_vm._v("Hugh Rashleigh and Royal Spa Brass")])]), _vm._v(" "), _c('p', [_c('a', {
    staticClass: "credits__link",
    attrs: {
      "href": "https://www.etsy.com/uk/shop/mustardandbloodart?ref=l2-shopheader-name"
    }
  }, [_vm._v("Jonny Nicholds")]), _vm._v(", "), _c('a', {
    staticClass: "credits__link",
    attrs: {
      "href": "https://en-gb.facebook.com/lucyannesalemusic/"
    }
  }, [_vm._v("Lucy Anne Sale")]), _vm._v(", "), _c('a', {
    staticClass: "credits__link",
    attrs: {
      "href": "http://wesfinch.co.uk/"
    }
  }, [_vm._v("Wes Finch")]), _vm._v(" and the Mustard & Blood Orchestra")])]), _vm._v(" "), _c('div', {
    staticClass: "credits__grid-item"
  }, [_c('p', {
    ref: "creditsBuffer",
    staticClass: "credits__item--is-buffer"
  }, [_c('a', {
    staticClass: "credits__link",
    attrs: {
      "href": "https://www.instagram.com/lizbuffcrowley/"
    }
  }, [_vm._v("Liz Crowley")]), _vm._v(" for organising and "), _c('a', {
    staticClass: "credits__link",
    attrs: {
      "href": "https://uk.linkedin.com/in/drew-coleman-7aa38147"
    }
  }, [_vm._v("Drew Coleman")]), _vm._v(" for recording:")]), _vm._v(" "), _c('p', [_vm._v("Adrian Tomaszewski")]), _vm._v(" "), _c('p', [_vm._v("Alexandru Kraus")]), _vm._v(" "), _c('p', [_vm._v("Barthe Makosso")]), _vm._v(" "), _c('p', [_vm._v("Brenna McCann")])]), _vm._v(" "), _c('div', {
    staticClass: "credits__grid-item"
  }, [_c('p', {
    staticClass: "credits__item--has-buffer",
    class: {
      'credits__item--has-buffer-large': _vm.bufferLarge
    }
  }, [_vm._v("Elena Fulea")]), _vm._v(" "), _c('p', [_vm._v("Elina Baltina")]), _vm._v(" "), _c('p', [_vm._v("Greta Lazdovska")]), _vm._v(" "), _c('p', [_vm._v("Jeffy Jigy")])]), _vm._v(" "), _c('div', {
    staticClass: "credits__grid-item"
  }, [_c('p', {
    staticClass: "credits__item--has-buffer credits__item--drop-buffer",
    class: {
      'credits__item--has-buffer-large': _vm.bufferLarge
    }
  }, [_vm._v("Mateuz Cetnarski")]), _vm._v(" "), _c('p', [_vm._v("Musa Nasibu")]), _vm._v(" "), _c('p', [_vm._v("Nimeshika Rathnapriyalage")]), _vm._v(" "), _c('p', [_vm._v("Vilario Fernandez")])])]), _vm._v(" "), (_vm.creditData.length) ? _c('p', [_vm._v("This viewing featured the work of:")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "credits__grid"
  }, _vm._l((_vm.creditData), function(credit, index) {
    return _c('div', {
      key: ("credit-" + index),
      staticClass: "credits__grid-item"
    }, [_c('p', {
      staticClass: "credits__grid-item-name"
    }, [_vm._v(_vm._s(credit.fullname))]), _vm._v(" "), _vm._l((_vm.getLinksFromCredit(credit.credit)), function(link, index) {
      return _c('a', {
        key: ("credit-" + (credit.fullName) + "-" + index),
        staticClass: "credits__grid-item-credit credits__link",
        attrs: {
          "href": link.link,
          "target": "_blank"
        }
      }, [_vm._v("\n                " + _vm._s(link.label) + "\n              ")])
    })], 2)
  }))])])])]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2635a0ea","transformToRequire":{"audio":"src"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Credits.vue
// module id = 223
// module chunks = 1